import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import AddVehicleModelIndex from "../../../../components/SidetabPages/Catalog/VehicleModel/AddVehicleModelIndex";

const AddVehicleModel = () => {
  return (
    <>
      <AnnouncementBar />
      <AddVehicleModelIndex />
    </>
  );
};
export default AddVehicleModel;
